var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { baseGapVariants, responsiveGapVariants } from '../../css/responsiveWhitespace.css';
import { getSpacingClasses } from '../../utils/spacings';
import { alignVariants, baseStyles } from './Stack.css';
export const Stack = React.forwardRef(function Stack(_a, ref) {
    var { align, as, children, className, spacing = 16 } = _a, rest = __rest(_a, ["align", "as", "children", "className", "spacing"]);
    const Component = as || 'div';
    const spacingClass = getSpacingClasses(spacing, baseGapVariants, responsiveGapVariants);
    return (_jsx(Component, Object.assign({}, rest, { className: cx(baseStyles, spacingClass, align && alignVariants[align], className), ref: ref, children: children })));
});
